export const es = {
  login: {
    TITLE: 'Iniciar Sesión',
    EMAIL: { TEXT: 'Correo', PLACEHOLDER: 'Correo electrónico' },
    PASSWORD: { TEXT: 'Contraseña', PLACEHOLDER: '**********' },
    RECOVER: { TEXT: 'Olvide mi contraseña' },
  },
  'password-recovery': {
    TITLE: 'Recuperar contraseña',
    SUCCESS: {
      SUMMARY: 'Correo enviado',
      DETAIL: 'Revisa tu correo y sigue las instrucciones',
    },
  },
  roles: {
    ADMIN: 'Administrador',
    SELLER: 'Vendedor',
    ESTIMATOR: 'Estimador',
  },
  strings: {
    SUMMARY: 'Resumen',
    LOGOUT_SUCCESS: 'Cerraste sesión con éxito',
    PROFILE: 'Perfil',
    HOME: 'Inicio',
    DASHBOARD: 'Dashboard',
    CALENDAR: 'Calendario',
    USERS: 'Usuarios',
    ARTICLES: 'Materiales',
    CATEGORIES: 'Categorias',
    TYPES: 'Tipos',
    METRICS: 'Unidades de medida',
    RM: 'Recepción de mercancia',
    PURCHASE_ORDERS: 'Órdenes de compra',
    INVENTORY: 'Inventario',
    HISTORY: 'Kardex',
    RECEPTION: 'Recepciones',
    SUPPLIERS: 'Proveedores',
    WELCOME_USER: '¡Bienvenido {attribute}!',
    CITY_NOT_FOUND: 'No encuentras una ciudad, agrégala',
    ARE_YOU_SURE: {
      TITLE: '{attribute}',
      TEXT: '¿Estás seguro de continuar, esta acción no se podrá revertir?',
    },
    ARE_YOU_SURE_APPLIED: {
      TITLE: '{attribute}',
      TEXT: 'Al aplicar esta salida tendrá un costo unitario de {attribute}',
    },
    ARE_YOU_SURE_CANCELLED: {
      TITLE: '{attribute}',
      TEXT: 'Al cancelar la orden de compra {attribute} no afectara en ninguna operación/actividad que tenga relación con esta orden de compra',
    },
    MODAL: {
      ADD: 'Agregar {attribute}',
      EDIT: 'Editar {attribute}',
      APPLIED: 'Aplicar {attribute}',
      SHOW: 'Ver {attribute}',
      RECEIVE: 'Recibir traspaso {attribute}',
      PROFILE: 'Mi perfil',
    },
    SOMETHING_WENT_WRONG: 'Ups! algo salio mal',
    CRUD_HELPER: '{attribute} con éxito',
    SUBTITLE_SUMMARY: 'Un resumen de sus {attribute}',
    SEARCH: 'Búsqueda',
    ORDER_BY: 'Ordernar',
    NO_DATA_TO_DISPLAY: 'Sin datos para mostrar',
    LOCATIONS: 'Localidades',
    LOCATION_DESTINATION: 'Localidad destino',
    OUT: 'Salida',
    INVITATIONS: 'Invitaciones',
    COMMENTS: 'Comentarios',
    ATTACHED: 'Adjuntos',
    BI: 'Business Intelligence',
    SMTP_PASSWORD_REPLACE:
      'Si ya existe una contraseña para el servicio de correos, se remplazará en el caso de ingresar una nueva',
  },
  filters: {
    TITLE: 'Filtros',
  },
  actions: {
    LOGOUT: 'Cerrar sesión',
    CANCEL: 'Cancelar',
    CANCELLED: 'Cancelado',
    CLOSE: 'Cerrar',
    ADD: 'Agregar',
    ACCEPT: 'Aceptar',
    SAVE: 'Guardar',
    EDIT: 'Editar',
    DELETE: 'Eliminar',
    EXPORT: 'Exportar',
    IMPORT: 'Importar',
    CHOOSE: 'Seleccionar',
    ACTIVATE: 'Activar',
    DETAIL: 'Detalle',
    ADDED: 'Guardado',
    UPDATED: 'Actualizado',
    DOWNLOADED: 'Descargado | Descargar',
    DELETED: 'Eliminado',
    SEE: 'Ver {attribute}',
    UPLOAD: 'Subir {attribute}',
    NEW: 'Nuevo {attribute}',
    APPROVE: 'Aprobar',
    'IN-TRANSIT': 'En tránsito',
    PRINT: 'Imprimir',
    ADD_ARTICLE: 'Agregar artículo',
    RECOVER: 'Recuperar',
    APPLIED: 'Aplicar',
    APPLY: 'Aplicar',
    ENTRY: 'Entrada',
    OUT: 'Salida',
    INACTIVE: 'Inactivar',
    SHOW_STATUS: 'Ver estatus',
    SEND: 'Enviar',
    RECEIVED: 'Recibido',
    RECEIVE: 'Recibir',
    DUPLICATE: 'Duplicar',
    SEND_EMAIL: 'Enviar correo',
  },
  settings: {
    TITLE: 'Configuración',
    THEME: 'Tema',
    THEME_MODE: { LIGHT: 'Claro', DARK: 'Obscuro' },
    LANG: 'Idioma',
  },
  locale: {
    ES: 'Español',
    EN: 'Ingles',
  },
  dashboard: {
    INVITATIONS_RECEIVED: 'Invitaciones recibidas',
    INVITATIONS_SEND_ON_TIME: 'Enviadas a tiempo',
    INVITATIONS_NOT_SEND: 'No enviadas',
    INVITATIONS_SENT_WRONG_TIME: 'Enviadas a destiempo',
    TOP_LEADS: 'Top Clientes',
    SUMMARY_LEADS: 'Resumen de Clientes',
    ON_TIME: 'A tiempo',
    NOT_SENT: 'No enviadas',
    WRONG_TIME: 'A destiempo',
    WON_VS_TOTALS: 'Ganadas vs recibidas',
  },
  users: {
    MODEL: 'Usuario | Usuarios',
    PASSWORD: 'Contraseña',
    PASSWORD_CONFIRM: 'Confirmar contraseña',
  },
  invitations: {
    MODEL: 'Invitación | Invitaciones',
    NEW: 'Nueva Invitación',
    CRITERIA: 'Criterios',
  },
  categories: {
    MODEL: 'Categoría | Categorías',
  },
  locations: {
    MODEL: 'Localidad | Localidades',
  },
  comments: {
    MODEL: 'Seguimiento | Segimientos',
    ESTIMATION_COMMENT: 'Seguimiento estimación',
    ESTIMATION_SELLER: 'Seguimiento Vendedor',
  },
  calendars: {
    TITLE: 'Calendario de fechas limite',
  },
  'follow-ups': {
    MODEL: 'Seguimiento | Segimientos',
  },
  columns: {
    INDICATOR: 'Indicador',
    USER: 'Usuario',
    PRODUCT: 'Producto',
    NAME: 'Nombre',
    PRICE: 'Precio',
    STATUS: 'Estatus',
    CREATED_AT: 'Fecha de creación',
    DATE: 'Fecha',
    AMOUNT: 'Monto',
    CURRENCY: 'Moneda',
    MXN: 'MXN',
    USD: 'USD',
    ACTIONS: 'Acciones',
    FOLIO: 'Folio',
    LAST_NAME: 'Apellido',
    EMAIL: 'Correo | Correos electrónicos',
    ROL: 'Rol',
    TITLE: 'Título',
    DESCRIPTION: 'Descripción',
    CATEGORY: 'Categoria',
    ID: 'ID',
    ARTICLE_NAME: 'Nombre artículo',
    ARTICLE: 'Artículo',
    QUANTITY: 'Cantidad {attribute}',
    CONTACT_NAME: 'Contacto',
    CONTACT_EMAIL: 'Mail',
    CONTACT_PHONE: 'Número',
    COUNTRY: 'País',
    PHONE: 'Teléfono',
    CUSTOMER: 'Cliente',
    PROJECT: 'Proyecto',
    SQ_FEET: 'Square feet | Tamaño | SF',
    LOCATION: 'Ubicación',
    DELIVERY_DATE: 'Fecha de entrega',
    PRIORITY: 'Prioridad',
    SELLER: 'Vendedor | Vendedores',
    LEAD: 'Lead | Leads | Cliente',
    STATE: 'Estado',
    DWS: 'DWS',
    TO_REVIEW: 'Revisado',
    SHEET: 'Lámina',
    PSS: 'PSS',
    JSS: 'JSS',
    MPER: 'IMPER',
    JF: 'JF',
    QTE: 'QTE',
    DRME: 'DRME',
    FOLLOW_UP: 'Follow up',
    CITY: 'Ciudad',
    ESTIMATOR: 'Estimador',
    JOST: 'Joist | J',
    STRUCTURE: 'Estructura | S',
    MISC: 'Misc | M',
    LAYER: 'Lámina | L',
    SMTP_PASSWORD: 'Contraseña para servicio de correos',
    SUBJECT: 'Asunto',
    COMMENTS: 'Comentarios',
    ATTACHMENTS: 'Archivos adjuntos',
  },
  status: {
    ACTIVED: 'Activo',
    DELETED: 'Eliminado',
    INACTIVED: 'Inactivo',
    REQUESTED: 'En proceso',
    PENDING: 'Pendiente',
    APPLIED: 'Aplicado',
    DONE: 'Completado',
    DRAFTED: 'Borrador',
    CANCELLED: 'Cancelado',
    RECEIVE: 'Recibir',
    RECEIVED: 'Recibida',
    APPROVE: 'Aprobado',
    APPROVED: 'Aprobado',
    IN_TRANSIT: 'En tránsito',
    SEND: 'Enviar',
    SENT: 'Enviado',
    IN_PROCESS: 'Procesando',
    SENT_ON_TIME: 'Enviado AT',
    SENT_WRONG_TIME: 'Enviado FT',
    WON: 'Ganado',
    LOST: 'Perdida',
    EXPIRED: 'Expirada',
    HOT: 'Caliente',
  },
  priority: {
    LOW: 'Bajo',
    MEDIUM: 'Media',
    HIGH: 'Alta',
  },
  validation: {
    MIN_ONE_EMAIL: 'Debe incluir al menos un correo electrónico',
    ACCEPTED: 'El campo {attribute} debe ser aceptado.',
    ACTIVE_URL: 'El campo {attribute} no es una URL válida.',
    AFTER: 'El campo {attribute} debe ser una fecha después a {date}.',
    AFTER_OR_EQUAL:
      'El campo {attribute} debe ser una fecha posterior o igual a {date}.',
    ALPHA: 'El campo {attribute} solo puede contener letras.',
    ALPHA_DASH:
      'El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.',
    ALPHA_NUM: 'El campo {attribute} solo puede contener letras y números.',
    ARRAY: 'El campo {attribute} debe ser una matriz.',
    BEFORE: 'El campo {attribute} debe ser una fecha antes de {date}.',
    BEFORE_OR_EQUAL:
      'El campo {attribute} debe ser una fecha antes o igual a {date}.',
    BETWEEN: {
      NUMERIC: 'El {attribute} debe estar entre {min} y {max}.',
      FILE: 'El {attribute} debe estar entre {min} y {max} kilobytes.',
      STRING: 'El {attribute} debe estar entre {min} y {max} caracteres.',
      ARRAY: 'El {attribute} debe estar entre {min} y {max} artículos.',
    },
    BOOLEAN: 'El campo {attribute} debe ser verdadero o falso.',
    CONFIRMED: 'El {attribute} la confirmación no coincide.',
    DATE: 'La {attribute} no es una fecha valida.',
    DATE_FORMAT: 'La {attribute} no coincide con el formato {format}.',
    DIFFERENT: 'El {attribute} y {other} deben ser diferentes.',
    DIGITS: 'El {attribute} deben ser {digits} dígitos.',
    DIGITS_BETWEEN: 'El {attribute} debe estar entre {min} y {max} dígitos.',
    DIMENSIONS: 'El {attribute} tiene dimensiones de imagen inválidas.',
    DISTINCT: 'El {attribute} campo tiene un valor duplicado.',
    EMAIL:
      'El campo {attribute} debe ser una dirección de correo electrónico válida.',
    EXISTS: 'El seleccionado {attribute} no es válido.',
    FILE: 'El {attribute} debe ser un archivo.',
    FILLED: 'El {attribute} campo debe tener un valor.',
    GT: {
      NUMERIC: 'El {attribute} debe ser mayor que {value}.',
      FILE: 'El {attribute} debe ser mayor que {value} kilobytes.',
      STRING: 'El {attribute} debe ser mayor que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener más que {value} artículos.',
    },
    GTE: {
      NUMERIC: 'El {attribute} debe ser mayor o igual que {value}.',
      FILE: 'El {attribute} debe ser mayor o igual que {value} kilobytes.',
      STRING: 'El {attribute} debe ser mayor o igual que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener {value} artículos o más.',
    },
    IMAGE: 'La {attribute} debe ser una imagen.',
    IN: 'El seleccionado {attribute} no es válido.',
    IN_ARRAY: 'El {attribute} campo no existe en {other}.',
    INTEGER: 'El {attribute} debe ser un entero.',
    IP: 'La {attribute} debe ser una dirección IP válida.',
    IPV4: 'La {attribute} debe ser una dirección IPv4 válida.',
    IPV6: 'La {attribute} debe ser una dirección IPv6 válida.',
    JSON: 'La {attribute} debe ser una cadena JSON válida.',
    LT: {
      NUMERIC: 'El {attribute} debe ser menor que {value}.',
      FILE: 'El {attribute} debe ser menor que {value} kilobytes.',
      STRING: 'El {attribute} debe ser menor que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener menos que {value} artículos.',
    },
    LTE: {
      NUMERIC: 'El {attribute} debe ser menor o igual {value}.',
      FILE: 'El {attribute} debe ser menor o igual {value} kilobytes.',
      STRING: 'El {attribute} debe ser menor o igual {value} caracteres.',
      ARRAY: 'El {attribute} no debe tener más de {value} artículos.',
    },
    MAX: {
      NUMERIC: 'El {attribute} no puede ser mayor que {max}.',
      FILE: 'El {attribute} no puede ser mayor que {max} kilobytes.',
      STRING: 'El {attribute} no puede ser mayor que {max} caracteres.',
      ARRAY: 'El {attribute} no puede tener más de {max} artículos.',
    },
    MIMES: 'El {attribute} must be a file of type: {values}.',
    MIMETYPES: 'Los {attribute} must be a file of type: {values}.',
    MIN: {
      NUMERIC: 'El campo {attribute} debe ser al menos de {min}.',
      FILE: 'El campo {attribute} debe ser al menos de {min} kilobytes.',
      STRING: 'El campo {attribute} debe ser al menos de {min} caracteres.',
      ARRAY: 'El campo {attribute} debe tener al menos {min} artículos.',
    },
    NOT_IN: 'El seleccionado {attribute} no es válido.',
    NOT_REGEX: 'El {attribute} formato no es válido.',
    NUMERIC: 'El campo {attribute} tiene que ser un número.',
    PRESENT: 'El campo {attribute} debe estar presente.',
    REGEX: 'El campo {attribute} formato no es válido.',
    REQUIRED: 'El campo {attribute} es requerido.',
    REQUIRED_IF: 'El campo {attribute} es requerido cuando {other} es {value}.',
    REQUIRED_UNLESS:
      'El campo {attribute} es requerido a menos que {other} es en {values}.',
    REQUIRED_WITH:
      'El campo {attribute} es requerido cuando {values} esta presente.',
    REQUIRED_WITH_ALL:
      'El campo {attribute} es requerido cuando {values} esta presente.',
    REQUIRED_WITHOUT:
      'El campo {attribute} es requerido cuando {values} no esta presente.',
    REQUIRED_WITHOUT_ALL:
      'El campo {attribute} es requerido cuando ninguno de {values} estan presentes.',
    SAME: 'El campo {attribute} debe coincidir con {other}.',
    SIZE: {
      NUMERIC: 'El {attribute} debe ser {size}.',
      FILE: 'El {attribute} debe ser {size} kilobytes.',
      STRING: 'El {attribute} debe ser {size} caracteres.',
      ARRAY: 'El {attribute} debe contener {size} artículos.',
    },
    STRING: 'El {attribute} debe ser un texto.',
    TIMEZONE: 'El {attribute} debe ser una zona válida.',
    UNIQUE: 'El {attribute} ya se ha tomado.',
    UPLOADED: 'El {attribute} no se pudo cargar.',
    URL: 'El {attribute} formato no válido.',
    PASSWORD_EQUALS: 'Las contraseñas no coinciden.',
    ATTRIBUTES: {},
  },
}
